import { makeStyles } from '@material-ui/core'

const styles = (heightContainer) =>
  makeStyles((theme) => ({
    root: {
      minWidth: 250,
      height: heightContainer || '100%',
      minHeight: 404,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    columnBox: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'start',
    },
    cardHeader: {
      padding: theme.spacing(2),
    },
    cardTitle: {},
    cardContent: {
      minHeight: 0,
      width: '100%',
      height: '100%',
      flex: 1,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    },
    paperContent: {
      minHeight: 'fit-content',
    },
  }))

export default styles
